module.exports = __webpack_public_path__ + "32f0996926745b48db2d6d4a5f2498c7.MP3";